import { render, staticRenderFns } from "./CustomerWrapper.vue?vue&type=template&id=1a9b3689&"
import script from "./CustomerWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomerWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports